import React from 'react';
import './App.scss';
import { TranslatorProvider } from "react-translate";
import translations from './translations';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import HomePage from './components/homepage';
import ContactPage from './components/contactpage';
import CongressPage from './components/congresspage';
// import RegisterPage from './components/registerpage';
import TbilisiPage from './components/tbilisipage';
import RegResultPage from './components/regresultpage';

class App extends React.Component {

  constructor(props) {
    super(props);

    this.languages = ['ka', 'en', 'ru'];

    this.state = {
      lang: this.languages[0]
    };

    this.switchLanguage = this.switchLanguage.bind(this);
    this.Home = this.Home.bind(this);
    this.Contact = this.Contact.bind(this);
    this.Congress = this.Congress.bind(this);
    // this.Register = this.Register.bind(this);
    // this.RegisterExcursion = this.RegisterExcursion.bind(this);
    this.Tbilisi = this.Tbilisi.bind(this);
    this.RegResult = this.RegResult.bind(this);
  }


  componentDidMount() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let queryLang = params.get('lang');
    let lang = (queryLang ? queryLang : localStorage.getItem('lang'));
    this.switchLanguage(lang);
  }


  switchLanguage = function(lang) {
    if (!lang || !this.languages.includes(lang))
      lang = this.state.lang;
    localStorage.setItem('lang', lang);
    this.setState({ lang });
    const titles = {
      ka: 'საქართველოს თმის აღდგენის საზოგადოება',
      en: 'Georgian society of hair restoration',
      ru: 'Грузинское общество восстановления волос'
    };
    document.title = 'GSHR.ge | ' + titles[lang];
  }



  NoMatch = function() {
    return (
      <div className="component noMatch">
        <h1>Page Not Found</h1>
      </div>
    );
  }


  Home = function() {
    let commonProps = { lang: this.state.lang, switchLanguage: this.switchLanguage };
    return <HomePage commonProps={commonProps} />;
  }


  Congress = function() {
    let commonProps = { lang: this.state.lang, switchLanguage: this.switchLanguage };
    return <CongressPage commonProps={commonProps} />;
  }


  Contact = function() {
    let commonProps = { lang: this.state.lang, switchLanguage: this.switchLanguage };
    return <ContactPage commonProps={commonProps} />;
  }


  // Register = function() {
  //   let commonProps = { lang: this.state.lang, switchLanguage: this.switchLanguage };
  //   return <RegisterPage commonProps={commonProps} />;
  // }

  // RegisterExcursion = function() {
  //   let commonProps = { lang: this.state.lang, switchLanguage: this.switchLanguage };
  //   return <RegisterPage commonProps={commonProps} mode="excursion" />;
  // }

  Tbilisi = function() {
    let commonProps = { lang: this.state.lang, switchLanguage: this.switchLanguage };
    return <TbilisiPage commonProps={commonProps} />
  }

  RegResult = function() {
    let commonProps = { lang: this.state.lang, switchLanguage: this.switchLanguage };
    return <RegResultPage commonProps={commonProps} />
  }


  render() {
    return (
      <div className="App">
        <TranslatorProvider translations={translations[this.state.lang]}>
          <Router>
            <Switch>
              <Route exact path="/" component={this.Home} />
              <Route exact path="/congress" component={this.Congress} />
              <Route exact path="/contact" component={this.Contact} />
              {/* <Route exact path="/register" component={this.Register} /> */}
              <Route exact path="/register/:result/:type" component={this.RegResult} />
              <Route exact path="/register/excursion" component={this.RegisterExcursion} />
              <Route exact path="/tbilisi" component={this.Tbilisi} />
              <Route component={this.NoMatch} />
            </Switch>
          </Router>
        </TranslatorProvider>
      </div>
    );
  }

}

export default App;
